export default __webpack_public_path__ + "static/media/014-sofa.94ba3fec.png";